export default "__VITE_ASSET__b934d0fb__"